import type { ReactNode } from 'react'

/** 设置子页面里的一节：标题 + 可选说明 + 内容。 */
export function SettingsSection({
  title,
  description,
  children,
}: {
  title: string
  description?: ReactNode
  children: ReactNode
}) {
  return (
    <section className="border-b border-line px-4 py-4">
      <h2 className="text-lg font-extrabold">{title}</h2>
      {description && <p className="mt-1 text-[15px] text-ink-muted">{description}</p>}
      <div className="mt-3">{children}</div>
    </section>
  )
}
